import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Col } from "reactstrap";
import {
  getFilterPath,
  getUrlParams,
  removeUrlParam,
} from "../../../../helpers/common";
import DatePosted from "./DatePosted";
import EmploymentType from "./EmploymentType";
import JobKeywords from "./JobKeywords";
import WorkExperience from "./WorkExperience";
import SalaryRange from "./SalaryRange";
import CandidateStatus from "./CandidateStatus";
import JobType from "./JobType";
const Sidebar = ({ source = "jobs-page" }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const hasCandidatesPage = source === "candidates-page";

  const onFilterChange = (filterName, filterValue) => {
    let params = getUrlParams(filterName, filterValue);
    let path = getFilterPath(params, hasCandidatesPage ? "candidates" : "jobs");
    navigate(path);
  };

  const handleClearFilter = (urlPrams) => {
    const params = removeUrlParam(urlPrams);
    let path = getFilterPath(params, hasCandidatesPage ? "candidates" : "jobs");
    navigate(path);
  };

  return (
    <React.Fragment>
      <Col lg={3}>
        <div className="side-bar mt-5 mt-lg-0">
          {/* Header Section */}
          <div className="d-flex align-items-center justify-content-between mb-3 px-1">
            <h5 className="fw-bold mb-0 text-dark">
              <i className="mdi mdi-filter-variant me-2 text-primary"></i>
              Filters
            </h5>
          </div>

          <div className="accordion" id="accordionExample">
            <DatePosted
              onFilterChange={onFilterChange}
              handleClearFilter={handleClearFilter}
              searchParams={searchParams}
            />
            <JobType
              onFilterChange={onFilterChange}
              handleClearFilter={handleClearFilter}
              searchParams={searchParams}
            />

            <WorkExperience
              onFilterChange={onFilterChange}
              handleClearFilter={handleClearFilter}
              searchParams={searchParams}
            />

            {/* <EmploymentType
      onFilterChange={onFilterChange}
      handleClearFilter={handleClearFilter}
      searchParams={searchParams}
    /> */}

            <SalaryRange
              onFilterChange={onFilterChange}
              searchParams={searchParams}
              handleClearFilter={handleClearFilter}
            />

            {source === "jobs-page" && (
              <>
                {/* 
        <JobKeywords
          onFilterChange={onFilterChange}
          handleClearFilter={handleClearFilter}
          searchParams={searchParams}
        /> */}
              </>
            )}
            {source === "candidates-page" && (
              <CandidateStatus
                onFilterChange={onFilterChange}
                handleClearFilter={handleClearFilter}
                searchParams={searchParams}
              />
            )}
          </div>
        </div>
      </Col>
    </React.Fragment>
  );
};

export default Sidebar;
